import { combineReducers } from "redux";

import uiReducer from "./uiReducer";
import homeReducer from "./homeReducer";
import authReducer from "./authReducer";
import lessonReducer from "./lessonReducer";
import behaviourReducer from "./behaviourReducer";
import quoteReducer from "./quoteReducer";
import classroomReducer from "./classroomReducer";
import favoriteReducer from "./favoriteReducer";
import resourceReducer from "./resourceReducer";
import searchReducer from "./searchReducer";
import lessonSettingsReducer from "./lessonSettingsReducer";
import toolsReducer from "./toolsReducer";
import subscriptionReducer from "./subscriptionReducer";
import notesReducer from "./notesReducer";

export default combineReducers({
  ui: uiReducer,
  auth: authReducer,
  home: homeReducer,
  lesson: lessonReducer,
  behaviour: behaviourReducer,
  quote: quoteReducer,
  classroom: classroomReducer,
  favorite: favoriteReducer,
  resource: resourceReducer,
  search: searchReducer,
  lessonSettings: lessonSettingsReducer,
  tools: toolsReducer,
  subscription: subscriptionReducer,
  notes: notesReducer
});
